import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Getapp = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 90%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 90%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        })
            .to(buttonRef.current, {
                rotateY: 360,
                duration: 0.8,
                ease: "power2.inOut",
            });
    }, []);
    return (
        <>
            <section className='getappmainprnt'>
                <div className="custom-container">
                    <div className="getappchldmain">
                        <div className="imgtoppostiongetapp">
                            <img className='img-fluid' src="\assets\Chatandpay\topleftgetapp.png" alt="" />
                        </div>

                        <p ref={paraRef}>
                            Take control of your privacy.
                        </p>
                        <h2 ref={textRef}>
                            Browse securely, ad-free, and without restrictions.
                        </h2>
                        <button ref={buttonRef} data-bs-toggle="modal"
                            data-bs-target="#exampleModal" className='primerybtn'>
                            Get Early Access
                        </button>

                        <div className="imgbottompostiongetapp">
                            <img className='img-fluid' src="\assets\Storageimages\bottomrightgetapp.png" alt="" />
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Getapp